import { nanoid } from 'nanoid';
import Rand from 'rand-seed';

import { TempIdMap } from '../types/tinybase';

/**
 * Returns a randomly generated ID with a negative value to be used as a temporary ID.
 * Can be used for entities created in the Tinybase store, before they are written to the relevant
 * data source
 * */
export const tempNumericId = () => {
  const rand = new Rand(nanoid());

  return -Math.round(rand.next() * 1e10);
};

export const isTempNumericId = (id: ScalarId) => Number(id) < 0;

export const newTempIdMap = (tempId: string, parentTempId = ''): TempIdMap => ({
  tempId,
  parentTempId,
  realId: '',
  parentRealId: '',
  timestamp: new Date().toISOString(),
});
